<template>
  <div class="invoice-com-wrap">
    <span v-if="routeType === 'invoiceRecordBj' || routeType === 'invoiceRecordGy'">
      <span class="yjh-active" @click.stop="changeBtn(3)">查看</span>
    </span>
    <div v-else>
      <span class="yjh-active" v-if="Number(rowData.invoice_status) === 0" @click.stop="changeBtn(1)">审核</span>
      <span class="yjh-active" v-if="Number(rowData.invoice_status) === 1" @click.stop="changeBtn(2)">填写物流信息</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: {
    rowData: Object,
    index: Number
  },
  computed: {
    routeType() {
      return this.$route.name
    }
  },
  methods: {
    // 审核/填写物流信息
    changeBtn(type) {
      // type: 1、审核；2、填写发票信息；3、查看-已寄出；4、查看-驳回
      if (type === 3) {
        type = Number(this.rowData.invoice_status) === 2 ? 4 : 3
      }
      const params = {
        operate: type,
        invoice_no: this.rowData.invoice_no,
        invoiceType: this.rowData.invoice_type
      }
      this.$emit('on-custom-comp', params)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/color.scss';
.invoice-com-wrap {
  color: $blue;
}
</style>
